@if (showNavigation) {
<!--
    `isFullScreenRoute` hides the chrome in place rather than swapping in a second
    <router-outlet> for full-screen routes. It has to: the flag is resolved on NavigationEnd,
    after the route component has already been activated, so switching outlets would destroy
    and re-create it. On the loading verification screen that means ngOnInit running twice and
    a second camera stream being acquired while the first is orphaned — the torch stays lit and
    the recording indicator stays on until the tab is closed. One outlet, chrome toggled
    around it.
-->
<div
    class="app-layout"
    [class.nav-collapsed]="isLeftNavCollapsed"
    [class.mobile-menu-open]="mobileMenuOpen()"
    [class.app-layout--fullscreen]="isFullScreenRoute">
    @if (!isFullScreenRoute) {
    <!-- Mobile backdrop overlay -->
    <div
        class="mobile-backdrop"
        *ngIf="(responsiveService.isMobile$ | async) && mobileMenuOpen()"
        (click)="closeMobileMenu()">
    </div>

    <!-- Mobile toggle button - outside left-navigation to avoid transform issues -->
    <button
        class="mobile-nav-toggle"
        *ngIf="(responsiveService.isMobile$ | async) && !mobileMenuOpen()"
        (click)="onMobileMenuStateChange(true)"
        aria-label="Open navigation menu">
        <mat-icon>chevron_right</mat-icon>
    </button>

    <app-left-navigation
        (toggleChange)="onLeftNavToggle($event)"
        (mobileMenuStateChange)="onMobileMenuStateChange($event)"
        [mobileMenuOpen]="mobileMenuOpen()">
    </app-left-navigation>
    }

    <div class="main-content">
        @if (!isFullScreenRoute) {
        <app-top-navigation
            [isLeftNavCollapsed]="isLeftNavCollapsed"
            [userName]="userName"
            [userAvatar]="userAvatar">
        </app-top-navigation>
        }

        <div class="content-body">
            <!-- Rendered once for the whole app so every page carries it, including
                 pages added later. Collapses to nothing when the session can write. -->
            <app-read-only-banner class="block mb-4"></app-read-only-banner>
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
} @else {
<!-- Hidden marker element for loading screen detection during OAuth callback -->
<!-- Without this, the loading screen polls forever waiting for visible content -->
<div class="app-init-marker" style="display: none;" aria-hidden="true"></div>
<router-outlet></router-outlet>
}
